/** @format */

import getConfig from "next/config"

import {
	NavigationApplicationURLControllerResponse,
	NavigationGetNavigationControllerResponse,
} from "_clients/BFFClient"

export const getTabbarStructure = () => {
	return {
		home: {
			id: "home",
			url: "",
		},
		menu: [
			{
				id: "agency",
				url: "",
			},
			{
				id: "agencyLI",
				url: "",
			},
			{
				id: "hyperviseur",
				url: "",
			},
			{
				id: "financialSpace",
				url: "",
			},
		],
		account: [
			{
				id: "accountSl",
				url: "",
			},
			{
				id: "accountLi",
				url: "",
			},
			{
				id: "logout",
				url: "",
			},
		],
		help: [
			{
				id: "onlineAssistance",
				url: "",
			},
			{
				id: "onlineFormation",
				url: "",
			},
			{
				id: "contactUs",
				url: "",
			},
		],
	}
}

const getSidebarStructure = () => {
	return [
		{
			id: "dashboard",
			label: "Tableau de bord",
			svg: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 14.66C1.84518 14.66 2.125 14.3802 2.125 14.035C2.125 13.7388 2.13932 13.4463 2.16726 13.1581L3.25824 13.3624C3.59752 13.426 3.92407 13.2024 3.98761 12.8632C4.05115 12.5239 3.82762 12.1973 3.48834 12.1338L2.37472 11.9252C2.74326 10.4013 3.50166 9.04608 4.52864 7.98668L5.22836 8.87274C5.44228 9.14364 5.83531 9.18982 6.1062 8.9759C6.3771 8.76198 6.42328 8.36895 6.20936 8.09806L5.46685 7.1578C6.61366 6.29425 7.98544 5.7497 9.46795 5.64392V6.8221C9.46795 7.16728 9.74777 7.4471 10.0929 7.4471C10.4381 7.4471 10.7179 7.16728 10.7179 6.8221V5.65955C12.185 5.80137 13.5375 6.37354 14.6626 7.25766L13.9589 8.14957C13.7451 8.42056 13.7914 8.81357 14.0624 9.02737C14.3334 9.24117 14.7264 9.19482 14.9402 8.92383L15.585 8.10663C16.5756 9.17058 17.3019 10.5163 17.6482 12.0226L16.6351 12.2124C16.2958 12.2759 16.0723 12.6025 16.1358 12.9418C16.1994 13.281 16.5259 13.5046 16.8652 13.441L17.8419 13.2581C17.8638 13.5139 17.875 13.773 17.875 14.035C17.875 14.3802 18.1548 14.66 18.5 14.66C18.8452 14.66 19.125 14.3802 19.125 14.035C19.125 8.7084 15.0479 4.375 10 4.375C4.95148 4.375 0.875 8.70806 0.875 14.035C0.875 14.3802 1.15482 14.66 1.5 14.66ZM9.30943 15.3067C8.41423 14.8904 8.01557 13.8063 8.39775 12.8778C9.03258 11.3379 11.1481 8.37359 12.1745 8.85091C13.1783 9.31601 12.4577 12.4412 11.6781 14.3421C11.2893 15.2904 10.2243 15.7329 9.30943 15.3067ZM10.8286 11.2941C11.0312 11.0101 11.2232 10.7594 11.3965 10.553C11.3557 10.8235 11.2935 11.1395 11.2129 11.4891C11.0078 12.3787 10.6707 13.5042 10.5216 13.8679C10.399 14.1669 10.0945 14.2934 9.83687 14.1734C9.55783 14.0437 9.42183 13.6739 9.55354 13.3539C9.67654 13.0555 10.2799 12.0628 10.8286 11.2941Z"/></svg>',
		},
		{
			id: "networkMembers",
			label: "Membres du réseau",
			svg: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9067 2.87451C11.1263 2.91505 10.4615 3.09843 9.92368 3.52035C9.38274 3.0808 8.6794 2.87481 7.89834 2.87481H7.85234C6.06761 2.96736 4.8217 3.86494 4.72989 6.05564L4.72934 6.12681C4.72901 6.09824 4.7243 6.15634 4.71978 6.23484C4.68316 6.87155 4.72035 7.59138 4.89158 8.28961C5.05403 8.95198 5.32404 9.51853 5.73174 9.95266C5.79993 10.0268 5.8711 10.0961 5.94524 10.1608C5.79636 10.3082 5.59098 10.4754 5.31718 10.6493C5.17382 10.7404 5.01762 10.8278 4.84797 10.9109C4.61957 11.0227 4.36485 11.1153 4.01201 11.2208C3.91021 11.2512 3.8194 11.2773 3.62128 11.3338C1.97622 11.8043 1.26506 12.2741 0.953648 13.5937C0.916541 13.7625 0.894684 13.9333 0.883669 14.1147C0.865119 14.4202 0.87757 14.7384 0.909298 15.0484C0.9222 15.1745 0.935389 15.2718 0.944946 15.3309C0.979905 15.5472 1.12558 15.7294 1.32888 15.8111C3.29916 16.603 5.56119 17.0342 7.94394 17.0342C8.63148 17.0342 9.30891 16.9983 9.97214 16.9283C10.6361 16.9987 11.3133 17.0345 11.9993 17.0345C14.3825 17.0345 16.6456 16.6031 18.6145 15.8114C18.8069 15.734 18.9485 15.5662 18.9922 15.3635C19.0058 15.3009 19.0241 15.1998 19.0419 15.0695C19.0857 14.7496 19.1029 14.4208 19.0772 14.1028C19.0617 13.9111 19.0308 13.73 18.9811 13.5606C18.6765 12.2977 17.9674 11.8299 16.3223 11.3429C16.1272 11.2853 16.037 11.2585 15.9371 11.2277C15.5811 11.1182 15.3253 11.0238 15.095 10.9111C14.926 10.8282 14.7699 10.7408 14.6266 10.6497C14.3143 10.4511 14.091 10.2614 13.9391 10.0997C13.9986 10.0414 14.0545 9.97939 14.1067 9.91377C14.481 9.51831 14.7509 8.95198 14.9131 8.28994C15.0842 7.59217 15.1212 6.87276 15.0844 6.23613C15.0822 6.19743 15.0799 6.16366 15.0781 6.13726L15.0781 6.13722L15.0781 6.13717C15.0762 6.10978 15.0749 6.09032 15.0747 6.08151C14.9837 3.84912 13.652 2.87451 11.9527 2.87451H11.9067ZM12.8159 10.701C12.5552 10.7687 12.2674 10.8108 11.9527 10.8285C11.118 10.8285 10.4345 10.5806 9.90807 10.0767L9.88479 10.1C10.0365 10.2615 10.2596 10.451 10.5718 10.6494C10.7151 10.7404 10.8713 10.8278 11.0407 10.9109C11.2716 11.0239 11.5279 11.1184 11.8857 11.2285C11.9846 11.2589 12.0738 11.2855 12.267 11.3425C13.9129 11.8298 14.6222 12.2978 14.9267 13.5613C14.9762 13.7303 15.0072 13.9109 15.0227 14.102C15.0486 14.4203 15.0313 14.7494 14.9875 15.0696C14.9697 15.1997 14.9514 15.3007 14.9378 15.3633C14.9229 15.4324 14.8966 15.4973 14.8609 15.5561C15.9014 15.3863 16.894 15.1245 17.8182 14.7795C17.8394 14.5812 17.8458 14.3828 17.8313 14.2035C17.8223 14.0921 17.8055 13.9938 17.7738 13.8834C17.5996 13.1626 17.2202 12.9123 15.9675 12.5415C15.7722 12.4839 15.6759 12.4552 15.5694 12.4224C15.1565 12.2953 14.8453 12.1805 14.5452 12.0337C14.3345 11.9304 14.1383 11.8205 13.956 11.7046C13.4269 11.3682 13.0568 11.0187 12.8159 10.701ZM10.7021 9.10177C10.6727 9.06998 10.6463 9.03976 10.6225 9.01069C10.7173 8.7875 10.7961 8.54564 10.8589 8.28944C11.0298 7.59164 11.0668 6.87218 11.03 6.23551C11.0277 6.19571 11.0253 6.16113 11.0235 6.13453C11.0218 6.10836 11.0205 6.08992 11.0203 6.08181C10.995 5.46727 10.8758 4.94804 10.6808 4.51824C10.996 4.2694 11.4205 4.15136 11.9527 4.12451C13.0425 4.12451 13.7657 4.6538 13.8247 6.12751C13.8271 6.16546 13.8291 6.19442 13.8308 6.22065L13.8309 6.22097C13.8329 6.25052 13.8346 6.27663 13.8365 6.30828C13.8667 6.83138 13.8357 7.43522 13.6991 7.99234C13.584 8.46185 13.4044 8.83869 13.1621 9.09666C12.9303 9.38461 12.54 9.54387 11.917 9.57953C11.3861 9.57851 10.9973 9.42322 10.7021 9.10177ZM9.64477 7.99204C9.52968 8.46188 9.35005 8.83894 9.10774 9.09696C8.8781 9.38211 8.49317 9.54106 7.88068 9.57876C7.62043 9.57725 7.3978 9.54235 7.20456 9.47303C7.16269 9.44238 7.11629 9.41648 7.06583 9.39642C7.03699 9.38496 7.0078 9.37579 6.97848 9.36883C6.85554 9.29803 6.74615 9.20906 6.64721 9.10156C6.40059 8.83889 6.22085 8.46177 6.10561 7.99187C5.96884 7.43421 5.93762 6.82987 5.96772 6.30663C5.97114 6.2471 5.97437 6.20728 5.97611 6.19022L5.97934 6.08181C6.03917 4.66741 6.70802 4.18555 7.885 4.12396L7.89834 4.12481C8.98766 4.12481 9.71061 4.65404 9.77087 6.1077L9.77034 6.12681C9.77269 6.16481 9.77466 6.1938 9.77645 6.22007L9.77645 6.22018L9.77646 6.22029L9.77648 6.22052L9.77649 6.22074C9.77849 6.2501 9.78026 6.27612 9.78208 6.30763C9.81231 6.83084 9.78127 7.4348 9.64477 7.99204ZM7.09666 10.7417C6.85526 11.0484 6.49431 11.3824 5.98748 11.7044C5.8051 11.8203 5.60872 11.9302 5.39758 12.0336C5.0962 12.1811 4.78293 12.295 4.37008 12.4184C4.26109 12.451 4.16349 12.4791 3.96497 12.5357C2.7168 12.8926 2.34555 13.1379 2.17244 13.8711C2.15249 13.962 2.1387 14.0698 2.13137 14.1905C2.12002 14.3774 2.12459 14.5813 2.1405 14.7849C3.88006 15.4318 5.8591 15.7842 7.94394 15.7842C10.0358 15.7842 12.0204 15.4298 13.7638 14.7792C13.7851 14.5808 13.7914 14.3826 13.7768 14.2032C13.7678 14.0922 13.751 13.9943 13.7194 13.884C13.5451 13.1626 13.1656 12.9122 11.9121 12.541C11.7188 12.484 11.6235 12.4556 11.5182 12.4232C11.1033 12.2956 10.7915 12.1806 10.491 12.0335C10.2801 11.9302 10.0838 11.8203 9.9014 11.7044C9.37362 11.369 9.00418 11.0205 8.76325 10.7035C8.51045 10.7695 8.2336 10.8106 7.93406 10.8278L7.89834 10.8288C7.61346 10.8288 7.34612 10.7998 7.09666 10.7417Z"/></svg>',
		},
		{
			id: "stats",
			label: "Statistiques",
			url: "",
			submenus: [
				{
					id: "networkStats",
					label: "Statistiques réseau",
				},
				{
					id: "listingStats",
					label: "Statistiques annonces",
				},
			],
		},
		{
			id: "hyperfaiseur",
			label: "Répartition des produits",
		},
		{
			id: "exportsHyperviseur",
			label: "Exports",
		},
		{
			id: "collaborators",
			label: "Accès collaborateurs",
		},
	]
}

export const generateSidebarStructure = async (
	dataFromBff: NavigationGetNavigationControllerResponse
) => {
	let sideBarStructure = []

	if (!dataFromBff || !dataFromBff.sideApplicationsURL) {
		return sideBarStructure
	}
	for (const sidebarElement of getSidebarStructure()) {
		const submenus = []
		for (const submenu of sidebarElement.submenus ?? []) {
			const submenuData = dataFromBff.sideApplicationsURL.find(
				s => s.code === submenu.id
			)
			if (!!submenuData) {
				submenus.push({
					...submenu,
					url: submenuData.app.url,
				})
			}
		}

		const data = dataFromBff.sideApplicationsURL.find(
			s => s.code === sidebarElement.id
		)
		if (!!data || submenus.length > 0) {
			if(sidebarElement.id === "hyperfaiseur") {
				let hyperfaiseurUrl = "";
				
				sideBarStructure.push({
					...sidebarElement,
					url: hyperfaiseurUrl,
					submenus: submenus.length > 0 ? submenus : null,
				});
            } 
			else {			
				sideBarStructure.push({
					...sidebarElement,
					url: data?.app?.url ?? sidebarElement.url,
					submenus: submenus.length > 0 ? submenus : null,
				})
			}
		}
	}

	return sideBarStructure
}

export const filteringTabBar = async (
	data: NavigationGetNavigationControllerResponse
) => {
	const structure = getTabbarStructure()

	if (data.isSuperAdminActive && !data.impersonatedUser) {
		// eslint-disable-next-line dot-notation
		structure["changeIdentity"] = {
			id: "changeIdentity",
			url: `${
				process.env.NEXT_PUBLIC_MY_SELOGER_PRO_LEGACY_URL
			}/superadmin`,
		}
	}

	if (data.impersonatedUser) {
		// eslint-disable-next-line dot-notation
		structure["resetIdentity"] = {
			id: "resetIdentity",
			url: "",
		}
	}

	if (data.applicationsURL) {
		fillHomeRoute(data.applicationsURL, structure.home)
		structure.menu = filterNavigationElement(
			data.applicationsURL,
			structure.menu
		)
		structure.account = filterNavigationElement(
			data.applicationsURL,
			structure.account
		)
		structure.help = filterNavigationElement(
			data.applicationsURL,
			structure.help
		)
	}

	return structure
}

export const filterNavigationElement = (
	activableLinks: NavigationApplicationURLControllerResponse[],
	element: any
): any => {
	return element.filter(tabLink => {
		const index = activableLinks.findIndex(
			activableLink => tabLink.id === activableLink.code
		)
		if (index !== -1) {
			tabLink.url = activableLinks[index].app.url
			return true
		} else {
			return false
		}
	})
}

export const fillHomeRoute = (
	activableLinks: NavigationApplicationURLControllerResponse[],
	element: any
): any => {
	const index = activableLinks.findIndex(
		activableLink => activableLink.code === "hyperviseur"
	)
	if (index !== -1) {
		element.url = activableLinks[index].app.url
	}
}
